import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["x2"]
const _hoisted_3 = ["stop-color"]
const _hoisted_4 = ["stop-color"]
const _hoisted_5 = {
  id: "color-gradient-full",
  x1: "0%",
  x2: "8%",
  y1: "0",
  y2: "0",
  gradientUnits: "userSpaceOnUse"
}
const _hoisted_6 = ["stop-color"]
const _hoisted_7 = ["stop-color"]
const _hoisted_8 = ["stop-color"]

import { computed } from "vue";
import { SafaIconProps } from "@/types";
import { Colors } from "@/util";
import SafaName from "./SafaName.vue";
import SafaLogo from "./SafaLogo.vue";


/**
 * Displays the SAFA icon.
 */
const __default__ = {
  name: "SafaIcon",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    hidden: { type: Boolean },
    iconOnly: { type: Boolean },
    clickable: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const className = computed(() => {
  let classNames = "icon-safa";

  if (props.clickable) {
    classNames += " clickable";
  }
  if (!props.hidden) {
    classNames += " visible";
  }
  if (props.iconOnly) {
    classNames += " logo";
  }

  return classNames;
});

const viewBox = computed(() => {
  if (props.iconOnly) {
    return "0 0 620 500";
  } else {
    return "0 0 1750 480";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    id: "logo-safa",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "80pt",
    viewBox: viewBox.value,
    preserveAspectRatio: "xMidYMid meet",
    class: _normalizeClass(className.value),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "color-gradient",
        x1: "5%",
        x2: props.iconOnly ? '100%' : '40%',
        y1: "0",
        y2: "0",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": _unref(Colors).gradient1
        }, null, 8, _hoisted_3),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": _unref(Colors).greenDark
        }, null, 8, _hoisted_4)
      ], 8, _hoisted_2),
      _createElementVNode("linearGradient", _hoisted_5, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": _unref(Colors).gradient1
        }, null, 8, _hoisted_6),
        _createElementVNode("stop", {
          offset: "50%",
          "stop-color": _unref(Colors).gradient5
        }, null, 8, _hoisted_7),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": _unref(Colors).gradient9
        }, null, 8, _hoisted_8)
      ])
    ]),
    _createVNode(SafaLogo),
    (!props.iconOnly)
      ? (_openBlock(), _createBlock(SafaName, { key: 0 }))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})